// extracted by mini-css-extract-plugin
export default {"FormSearch":"FormSearch_FormSearch__7ixRy","FormGroup":"FormSearch_FormGroup__3i9Og","FormItem":"FormSearch_FormItem__Vr6wL","TextLabel":"FormSearch_TextLabel__Qpp4D"};